import React from "react";
import { DmLoader } from "dm-react-ui";

export default () => {
    return <div>
        <span style={{ position: "relative", top: "42vh", left: "50%" }}>
            <DmLoader />
        </span>
    </div>
}